// extracted by mini-css-extract-plugin
export var circle = "_1d-2";
export var icon = "_1d-a";
export var iconHighlight = "_1d-0";
export var lg = "_1d-8";
export var md = "_1d-7";
export var outline = "_1d-4";
export var sm = "_1d-6";
export var square = "_1d-1";
export var xl = "_1d-9";
export var xs = "_1d-5";
export var xxs = "_1d-3";